import React from 'react'
import { withTranslation } from 'react-i18next'
import DocumentTitle from 'react-document-title'
import * as _ from 'lodash'

import { withRouter } from 'react-router-dom'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// core components
import Section from 'components/Section/Section'

// Utils
import compose from 'utils/compose'

// REDIX INIT
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ValidateDocument } from '../../redux/actions'
import { GetThemeColorFromStorage } from '../../redux/api/themeColor'

// @Assets and Styles
import {
	Container,
	LinkEmail,
	LinkText,
	Snack,
} from './styles'
import registerStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import getFromStorage from './helpers/getFromStorage'

import Axios from 'axios'
import SnackDefault from 'components/SnackDefault'
import { envs } from '../../redux/api/windowServerData'
import { getProgramTitle } from '../../utils/utils'
import { GetContact } from '../../redux/api/footer'
import { GetTenantVersion } from '../../redux/api/About'
import { Box, Grid, Typography } from '@mui/material'
import Footer from '../CreateUser/components/Footer'
import Header from '../CreateUser/components/Header'
import { hideOnEcommerce, isEcommerce } from '../../utils'

class AuthenticateAccess extends React.Component {
	constructor(props) {
		super(props)
		this.containerRef = React.createRef()
		this.state = {
			alert: '',
			tenant: '',
			alertError: '',
			themeColor: GetThemeColorFromStorage(),
			snackStatus: Snack,
			consumerData: {},
		}
	}

	getTenantVersion = async () => {
		try {
			const response = await GetTenantVersion()

			if (response?.status === 200 && response?.data) {
				this.setState({
					tenant: response?.data,
				})
			}
		} catch (error) {
			console.log('error', error)
		}
	}



	sendEmailConfirmationToken = async (e) => {
		const { t } = this.props
		const cpfUser = getFromStorage('cpfUser')
		const consumerData = getFromStorage('consumerSMS')
		const cpf = cpfUser ?? consumerData?.consumer?.cpf

		const response = await Axios(
			`${envs.REACT_APP_GERMINI_API_URL}/Consumer/SendEmailConfirmationToken?cpfCnpj=${cpf}`,
			{
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json-patch+json',
					appId: 'CSM1803',
					// companyInternalName: 'germini',
				},
				Accept: 'application/json',
				body: `{}`,
			},
		)

		const { status, data } = response

		if (status === 200) {
			const { errors } = data

			if (errors?.length > 0) {
				this.setState({
					snackStatus: {
						open: true,
						text: t(errors[0].message),
						severity: 'error',
					},
				})
				return
			}

			this.setState({
				snackStatus: {
					open: true,
					text: 'E-mail enviado com sucesso!',
					severity: 'success',
				},
			})
		}
	}

	GetContactInfo = async () => {
		const contact = await GetContact()
		contact && this.setState({ consumerData: contact })
	}

	componentDidMount() {
		this.GetContactInfo()
		if (this.state.tenant === '') {
			this.getTenantVersion()
		}

		if (isEcommerce) {
			this.sendHeight = () => {
				const height = this.containerRef.current ? this.containerRef.current.scrollHeight : document.documentElement.scrollHeight
				window.parent.postMessage({ action: 'resize', height }, '*')
			}
			this.observer = new ResizeObserver(this.sendHeight)
			const appRoot = this.containerRef.current || document.getElementById('root') || document.body
			this.observer.observe(appRoot)
			window.addEventListener('resize', this.sendHeight)
			this.sendHeight()
		}
	}

	componentWillUnmount() {
		if (this.observer) {
			this.observer.disconnect()
			window.removeEventListener('resize', this.sendHeight)
		}
	}

	render() {
		const { t } = this.props

		const _title =
			localStorage.getItem('programName') ??
			`Fidelidade - ${t('TITLE_REGISTER_CONFIRMATION')}`

		return (
			<Container ref={this.containerRef} style={isEcommerce ? { minHeight: 'auto', height: 'auto', overflow: 'hidden' } : {}}>
				{this.state.alert}
				{this.state.alertError}
				<DocumentTitle title={getProgramTitle(_title)} />

				<Grid container justify="center" minHeight={isEcommerce ? 'auto' : '100vh'}>
					<SnackDefault
						snackStatus={this.state.snackStatus}
						handleCloseSnack={() =>
							this.setState({ snackStatus: Snack })
						}
					/>

					<Grid
						item
						md={isEcommerce ? 12 : 8}
						xs={12}
						sm={12}
						container
						alignItems={isEcommerce ? "center" : "flex-start"}
						justifyContent="center"
					>
						<Box
							width="100%"
							maxWidth="590px"
							display="flex"
							flexDirection="column"
							gap="10px"
							p={{
								xs: '10px',
								sm: '20px',
								md: '0px',
							}}
						>
							{hideOnEcommerce(
								<Box mb="35px" mt="20px">
									<Header isOptions={false} />
								</Box>
							)}

							<Section title={t('TITLE_ACCESS_AUTHENTICATION')} divider={!isEcommerce} />

							<Box display="flex" flexDirection="column" gap="20px">
								<Typography variant='body2' color="#333333" sx={{ font: "normal normal normal 15px/30px Roboto" }}>
									Foi enviado um link para o seu e-mail,{' '}
									<strong>acesse</strong> e <strong>confirme</strong> o seu cadastro.
								</Typography>
								<Typography variant='body2' color="#333333" sx={{ font: "normal normal normal 15px/30px Roboto" }}>
									Se o e-mail não estiver na caixa de entrada, verifique suas pastas. Ele pode ter sido movido por um filtro de spam ou regra de e-mail,
									nesse caso ele poderá estar na pasta Spam, Indesejadas, Lixo, Itens Apagados ou Arquivo.
								</Typography>

								<Typography variant='body2' color="#333333" sx={{ font: "normal normal normal 15px/30px Roboto" }}>
									É importante que seu número de telefone esteja correto, pois você receberá um sms com o código de ativação após a confirmação do seu e-mail.
									Caso você não receba o e-mail, clique{' '}
									<LinkText
										onClick={this.sendEmailConfirmationToken}
									>
										aqui
									</LinkText> para o e-mail ser reenviado.
								</Typography>
							</Box>
							<Typography variant='body2' color="#333333" sx={{ font: "normal normal normal 15px/30px Roboto" }}>
								Se tiver problemas com o código token entre em
								contato com: <br />
								<Box
									component="b"
									color="#333333"
									themeColor={this.state.themeColor}
									onClick={() => {
										window.open(
											`mailto:${this.state.consumerData
												?.contactEmail || ''
											}`,
											'_blank',
										)
									}}
								>
									{this.state.consumerData?.contactEmail ||
										''}
								</Box>
							</Typography>
						</Box>
					</Grid>
					{hideOnEcommerce(
						<Grid
							item
							xs={12}
							sm={12}
							md={4}
							sx={{
								mt: {
									xs: '30px',
									sm: '0px',
									md: '0px',
								}
							}}
						>
							<Footer contact={this.state.consumerData} />
						</Grid>
					)}
				</Grid>
			</Container>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		userPost: state.users.userPost,
		userCpf: state.users.userCpf,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ ValidateDocument }, dispatch)

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(registerStyle),
	withTranslation(),
	withRouter,
)(AuthenticateAccess)
